"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
OrderListController.$inject = ['$scope', 'api', '_orders', 'notify', '_download', '$location', '$q'];
function OrderListController($scope, api, _orders, notify, _download, $location, $q) {
    $scope.selected = {};
    $scope.selectedStickerOrder = {};
    $scope.init = true;
    $scope.dropdownOpen = false;
    $scope.selectedOption = 1;
    $scope.accordion = {
        products: true,
        stickers: true
    };
    $scope.toggleDropdown = function ($event) {
        $event.stopPropagation();
        $scope.dropdownOpen = !$scope.dropdownOpen;
    };
    $scope.selectDropdownOption = function (option) {
        $scope.selectedOption = option;
        $scope.open();
        $scope.dropdownOpen = false;
    };
    $scope.toggleTableDropdown = function (order, $event) {
        if (order.status !== 'confirmed') {
            return;
        }
        $event.stopPropagation();
        // Close all other dropdowns
        if ($scope.orders && $scope.orders.items) {
            $scope.orders.items.forEach(function (o) {
                if (o.order_id !== order.order_id) {
                    o.dropdownOpen = false;
                }
            });
        }
        order.dropdownOpen = !order.dropdownOpen;
    };
    $scope.selectTableDropdownOption = function (order, option) {
        $scope.selectedOption = option;
        $scope.selectedStickerOrder = order;
        order.dropdownOpen = false;
        document.getElementById("listFile").click();
    };
    angular.element(document).on('click', function () {
        var needsApply = false;
        if ($scope.dropdownOpen) {
            $scope.dropdownOpen = false;
            needsApply = true;
        }
        // Close all table dropdowns
        if ($scope.orders && $scope.orders.items) {
            $scope.orders.items.forEach(function (order) {
                if (order.dropdownOpen) {
                    order.dropdownOpen = false;
                    needsApply = true;
                }
            });
        }
        if (needsApply) {
            $scope.$apply();
        }
    });
    $scope.select = function (order) {
        $location.search('orderView', order.order_id);
    };
    $scope.$on('refreshList', function (e, params) {
        refresh(params[0]);
    });
    function refresh(params) {
        $scope.loading = true;
        _orders.fetchExternal(params).then(function (items) {
            $scope.loading = false;
            $scope.orders = {
                items: items.data,
                _meta: { total: items.pagination.total_items }
            };
            var id = $location.search().orderView;
            if ($scope.init && id) {
                var order = _.find($scope.orders.items, { order_id: parseInt(id) });
                if (order) {
                    $scope.select(order);
                    $scope.init = false;
                }
            }
            if ($scope.selected.order_id) {
                var ord = _.find($scope.orders.items, { order_id: $scope.selected.order_id });
                if (ord) {
                    $scope.selected.status = ord.status;
                    $scope.selected.reservation = ord.reservation;
                }
            }
        }, function (err) {
            $scope.loading = false;
            if (err.data.error.details && err.data.error.details.locale) {
                notify.error(err.data.error.details.locale.rs);
            }
            else {
                notify.error(err.data.error.message);
            }
        });
    }
    $scope.cancel = function (order) {
        order.loading = true;
        _orders.cancelOrder(order.order_id).then(function (r) {
            refresh();
            notify.success('Uspešno ste otkazali porudžbinu.');
            order.loading = false;
        }, function (error) {
            if (error) {
                console.log(error);
                if (error.details && error.details.locale) {
                    notify.error(error.details.locale.rs);
                }
                else {
                    notify.error(error.message);
                }
            }
            order.loading = false;
        });
    };
    $scope.confirmReservation = function (order) {
        order.loading = true;
        _orders.confirmReservation(order.order_id).then(function (r) {
            refresh();
            notify.success('Uspešno ste potvrdili rezervaciju.');
            order.loading = false;
        }, function (error) {
            if (error) {
                if (error.details && error.details.locale) {
                    notify.error(error.details.locale.rs);
                }
                else {
                    notify.error(error.message);
                }
            }
            order.loading = false;
        });
    };
    $scope.$watch(function () {
        return $location.search().orderView;
    }, function (valn, valo) {
        if (valn !== valo) {
            if (valn) {
                var order = _.find($scope.orders.items, { order_id: parseInt(valn) });
                getDetails(order);
            }
            else {
                $scope.selected = {};
            }
        }
    });
    function getDetails(order) {
        $scope.loadingProduct = true;
        _orders.getExternalOrder(order.order_id)
            .then(function (response) {
            $scope.loadingProduct = false;
            $scope.selected = order;
            $scope.selected.products = response.items;
            $scope.selected.stickers = response.stickers;
        }, function (error) {
            $scope.loadingProduct = false;
            if (error.data.error.details && error.data.error.details.locale) {
                notify.error(error.data.error.details.locale.rs);
            }
            else {
                notify.error(error.data.error.message);
            }
        });
    }
    $scope.print = function (order) {
        order.loading = true;
        _download.print('b2border', order.order_id).then(function (response) {
            order.loading = false;
        }, function (error) {
            order.loading = false;
            console.log(error);
        });
    };
    $scope.close = function () {
        $scope.selected = {};
        $location.search('orderView', null);
    };
    $scope.open = function () {
        document.getElementById("file").click();
    };
    $scope.openList = function (order) {
        if (order.status !== 'confirmed') {
            return;
        }
        $scope.selectedStickerOrder = order;
        document.getElementById("listFile").click();
    };
    $scope.fileChangedList = function (files) {
        var file = files[0];
        if (!file)
            return;
        _orders.uploadDeliveryStickers($scope.selectedStickerOrder.order_id, file, $scope.selectedOption)
            .then(function (response) {
            if ($scope.selected && $scope.selected.order_id === $scope.selectedStickerOrder.order_id) {
                getDetails($scope.selected);
            }
            $scope.selectedStickerOrder = {};
        })
            .catch(function (error) {
            $scope.selectedStickerOrder = {};
            if (error.data.error.details && error.data.error.details.locale) {
                notify.error(error.data.error.details.locale.rs);
            }
            else {
                notify.error('Greška prilikom čuvanja fajla. (' + error.data.error.message + ')');
            }
        });
        $scope.$apply();
    };
    $scope.fileChanged = function (files) {
        var file = files[0];
        if (!file)
            return;
        _orders.uploadDeliveryStickers($scope.selected.order_id, file, $scope.selectedOption)
            .then(function (response) {
            getDetails($scope.selected);
        })
            .catch(function (error) {
            if (error.data) {
                notify.error(error.data.error.message);
            }
        });
        $scope.$apply();
    };
}
exports.OrderListController = OrderListController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/order-list/controllers/OrderListController.js
// module id = 415
// module chunks = 0